import { Module } from 'vuex';
import { GlobalState } from '../types';
import { AuthState } from './types';

import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export const state: AuthState = {
    session: null,
    user: null,
    lastForgot: null,
};

const namespaced: boolean = true;
export const auth: Module<AuthState, GlobalState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
